<template>
  <q-chip
    v-if="difference < 0"
    color="grey-10"
    text-color="light-green-14"
    size="sm"
    icon="trending_down"
    class="text-weight-medium"
  >
    {{ (difference).toFixed(2) }}%
  </q-chip>
  <q-chip
    v-else-if="difference > 0"
    color="grey-10"
    text-color="red-14"
    size="sm"
    icon="trending_up"
    class="text-weight-medium"
  >
    +{{ (difference).toFixed(2) }}%
  </q-chip>
  <q-chip
    v-else
    color="grey-10"
    text-color="yellow-6"
    size="sm"
    icon="trending_flat"/>
</template>
<script>
export default {
  name: "DrinkTrendChip",
  props: {
    difference: Number
  },
}
</script>
  